/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// routing
import {Redirect, Switch} from 'react-router';
import { PrivateRoute } from 'utils/privateRoute';
// structure
import SubDivision from 'material/structure/subdivision/subdivision';
// // pages
import EmbedContent from 'pages/dashboard/embeds/analytics/embedcontent/embedcontent_container';
// // styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/analytics/embed_analytics_styles';



/* ========== ~~~~~~~~~~ EMBED ANALYTICS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const EmbedAnalytics = (props) => {
    return (
        <Switch>
            <SubDivision name={`embedAnalytics`} klass={props.classes.embedAnalytics}>
                <div id={`main`}>
                    <Switch>
                        {/*<Route path='/dashboard/embeds/analytics/embedcontent' component={EmbedContent} />*/}
                        <PrivateRoute permitted={props.isDataReceived} exact path='/dashboard/embeds/analytics/embedcontent' redirectTo='/dashboard/embeds' component={EmbedContent} />
                        <Redirect to='/error/404' />
                    </Switch>
                </div>
            </SubDivision>
        </Switch>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedAnalytics);
